import createReactComponent from '../createReactComponent';
export default createReactComponent('map-cancel', 'IconMapCancel', [
  ['path', { d: 'M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8', key: 'svg-0' }],
  ['path', { d: 'M9 4v13', key: 'svg-1' }],
  ['path', { d: 'M15 7v6', key: 'svg-2' }],
  ['path', { d: 'M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-3' }],
  ['path', { d: 'M17 21l4 -4', key: 'svg-4' }],
]);
